import { FC, ChangeEvent } from 'react';
import './TextInput.scss';

interface TextInputProps {
  name: string;
  value?: string;
  defaultValue?: string;
  placeholder?: string;
  errorMessage?: string;
  isError?: boolean;
  onChange?: (e: ChangeEvent<HTMLInputElement>, name: any) => void;
  isDisabled?: boolean;
  title?: string;
  type?: string;
  style?: any;
  id?: string;
  maxLength? : number;
}

const TextInput: FC<TextInputProps> = ({
  name,
  value,
  defaultValue,
  placeholder,
  errorMessage,
  isError,
  onChange,
  isDisabled,
  title,
  type,
  style,
  id,
  maxLength
}) => {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (onChange) onChange(e, name);
  };

  const handleWheel = (event: React.WheelEvent<HTMLInputElement>) => {
    if (event.currentTarget === document.activeElement) {
      event.currentTarget.blur();
    }
  };

  return (
    <div className='input-wrapper' style={style}>
      {title && <span className='text-input-title'>{title}</span>}
      <input
        name={name}
        id={id}
        type={type ?? 'text'}
        placeholder={placeholder}
        defaultValue={defaultValue}
        onWheel={handleWheel}
        value={value}
        maxLength={maxLength}
        onChange={handleChange}
        className={`text-input ${isError ? 'text-input-error' : ''}`}
        disabled={isDisabled}
      />
      {isError && errorMessage && (
        <div className='error-message'>{errorMessage}</div>
      )}
    </div>
  );
};

export default TextInput;
